import React from "react";
import EmailForm from "../../components/email-form/email-form";
import FeaturedSong from "../../components/featured-song/featured-song";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import LinkTree from "../../components/link-tree/link-tree";

export default function HomeView() {
    return (
        <>
            <Header></Header>
            <FeaturedSong></FeaturedSong>
            <LinkTree></LinkTree>
            <EmailForm></EmailForm>
            <Footer></Footer>
        </>
    )
}